import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Radio from 'components/form/Radio';
import STATES from 'constant/states';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import useSnack from 'hooks/useSnack';
import { useMutation } from '@apollo/react-hooks';
import extend from 'lodash/extend';
import Box from '@material-ui/core/Box';
import CheckboxGroup from 'components/form/CheckboxGroup';

const FormItem = Form.FormItem;
const SCHOOL_TYPE = [
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' },
  { label: 'Other', value: 'other' },
];

const HighSchoolForm = ({
  user,
  highschool_info,
  disableCard,
  isSkip,
  saveText,
  onSkip,
  step,
  form: { getFieldDecorator, validateFields },
  history,
  editable,
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      values.highschool_state = values.highschool_state?.value;
      values = { ...values, completed: true };
      return update({
        variables: {
          id: user.id,
          input: {
            highschool_info: extend(highschool_info, values),
          },
        },
      }).then(
        () => {
          snack.success('Profile saved');
          step && history.push(`/onboarding/${step + 1}`);
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  return (
    <Card className={classes.card} elevation={disableCard && 0}>
      <CardContent className={classes.cardContent}>
        <Typography gutterBottom variant="h5">
          High School Info
        </Typography>
        <Box marginTop={3} maxWidth={500} width="100%">
          <Form>
            <FormItem>
              {getFieldDecorator('highschool_name', {
                initialValue: highschool_info?.highschool_name,
                rules: [
                  { required: true, message: 'High School Name is required' },
                ],
              })(
                <Input
                  disabled={!editable}
                  label="High School Name"
                  placeholder="Enter school name"
                />,
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('highschool_city', {
                initialValue: highschool_info?.highschool_city,
                rules: [
                  { required: true, message: 'High School City is required' },
                ],
              })(
                <Input
                  disabled={!editable}
                  label="High School City"
                  placeholder="Enter city of the school"
                />,
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('highschool_state', {
                initialValue: STATES.find(
                  (s) => s.value === highschool_info?.highschool_state,
                ),
                rules: [
                  { required: true, message: 'High School State is required' },
                ],
              })(
                <Select
                  disabled={!editable}
                  isMulti={false}
                  options={STATES}
                  label="High School State"
                />,
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('highschool_type', {
                initialValue: highschool_info?.highschool_type,
              })(
                <Radio
                  disabled={!editable}
                  row
                  size="small"
                  options={SCHOOL_TYPE}
                  label="High School Type"
                  // hint="Check the type of school you attend. If you’ve attend more than one high school, feel free to select multiple options"
                />,
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('graduation_year', {
                initialValue: highschool_info?.graduation_year,
                rules: [
                  { required: true, message: 'Graduation Year is required' },
                ],
              })(
                <Input
                  disabled={!editable}
                  type="number"
                  label="Graduation Year"
                />,
              )}
            </FormItem>
          </Form>
        </Box>
      </CardContent>
      {!disableCard && <Divider />}
      <CardContent className="actions">
        <Box display="flex" justifyContent="center">
          {isSkip && (
            <div style={{ marginRight: 24 }}>
              <Button size="large" onClick={onSkip} variant="outlined">
                Skip
              </Button>
            </div>
          )}
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={onSubmit}
            disabled={!editable}
          >
            {saveText || 'Save'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Form.create()(HighSchoolForm);
